export default "__VITE_ASSET__DrmReT0s__"